import { useState, memo, useCallback } from 'react';
import StageButton from '../StageButton';
import { StyledTableCell } from 'Utils';

const Doc = ({ order, loginUser, pageName, setSelectedOrder }) => {
    const getStatus = () => {
        var stage = {};
        if (order.customsStatus) {
            stage.notes = "";
            if (order.customsStatus <= 1)
                stage.status = "NOT_STARTED";
            else if (order.customsStatus <= 10)
                stage.status = "IN_PROGRESS";
            else if (order.customsStatus <= 20)
                stage.status = "CustomsYellow";
            else if (order.customsStatus <= 30)
                stage.status = "CustomsAIGreen";
            else if (order.customsStatus <= 40)
                stage.status = "SUCCESS";
            else if (order.customsStatus <= 50)
                stage.status = "FAILED";
        } else {
            stage.status = "NOT_STARTED";
            stage.notes = "";
        }
        return stage
    }
    const onHandleOpenDialog = () => {
        setSelectedOrder(order);
    }

    return (
        <StyledTableCell style={{ width: "5vw", p: 0 }}>
            <StageButton stage={getStatus()} onHandleOpenDialog={onHandleOpenDialog} stageName='Doc' loginUser={loginUser} />
        </StyledTableCell>
    );
};

export default memo(Doc);
